import { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'reactGarden/Glyph'

const Form = ({ onInputChange, onFormSubmit }) => {
  const shadowInput = useRef(null)

  const handleInputChange = useCallback(
    event => {
      shadowInput.current.value = event.target.value
      onInputChange(event)
    },
    [onInputChange]
  )

  return (
    <form
      className="quick-search-form"
      action="/search"
      autoComplete="off"
      role="search"
      onSubmit={onFormSubmit}
    >
      <input
        className="search-input"
        type="text"
        name="term"
        placeholder="Buscar"
        aria-label="Buscar"
        onChange={handleInputChange}
      />

      <input type="hidden" name="searchTerm" ref={shadowInput} />
      <input type="hidden" name="searchType" value="default" />

      <button
        aria-label="Fazer a busca"
        className="search-button color-neutral"
        type="submit"
      >
        <Glyph glyph="magnifier" />
      </button>
    </form>
  )
}

Form.propTypes = {
  onInputChange: PropTypes.func
}

export default Form
